import { ISuperAdminMyAccountContainerProps } from "./SuperAdminMyAccount.interfaces";
import SuperAdminMyAccountView from "./SuperAdminMyAccount.view";
import { useEffect, useState } from "react";
import { SuperAdminService } from "../../Services";

export default function SuperAdminMyAccountContainer(
    props: ISuperAdminMyAccountContainerProps
) {
    const [selection, setSelection] = useState("basic-details");
    const [showPassword, setShowPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const handleSelection = (i: string) => {
        setSelection(i);
    };
    const handleSetShowPassword = (i: boolean) => {
        setShowPassword(i);
    };
    const handleSetShowNewPassword = (i: boolean) => {
        setShowNewPassword(i);
    };
    const handleSetShowConfirmPassword = (i: boolean) => {
        setShowConfirmPassword(i);
    };
    const handleSetCurrentPassword = (i: string) => {
        setCurrentPassword(i);
    };
    const handleSetNewPassword = (i: string) => {
        setNewPassword(i);
    };
    const handleSetConfirmPassword = (i: string) => {
        setConfirmPassword(i);
    };
    const [superAdminUser, setSuperAdminUser] = useState({});
    const fetchSuperAdminUser = async () => {
        try {
            const data = await SuperAdminService.fetch();

            if (data && data.data) {
                setSuperAdminUser(data.data.superAdmin);
                return;
            } else throw new Error("User not found");
        } catch (error) {
            console.error(error);
            // window.location.href = "/super-admin/home";
        }
    };

    useEffect(() => {
        fetchSuperAdminUser();
    }, []);

    return (
        <>
            <SuperAdminMyAccountView
                selection={selection}
                showPassword={showPassword}
                showNewPassword={showNewPassword}
                showConfirmPassword={showConfirmPassword}
                currentPassword={currentPassword}
                newPassword={newPassword}
                confirmPassword={confirmPassword}
                handleSelection={handleSelection}
                handleSetShowPassword={handleSetShowPassword}
                handleSetConfirmPassword={handleSetConfirmPassword}
                handleSetNewPassword={handleSetNewPassword}
                handleSetCurrentPassword={handleSetCurrentPassword}
                handleSetShowNewPassword={handleSetShowNewPassword}
                handleSetShowConfirmPassword={handleSetShowConfirmPassword}
                superAdminUser={superAdminUser}
            />
        </>
    );
}
